module.exports = __webpack_public_path__ + "static/media/dblogo.0ed3fe36.png";